import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { MessageService } from '../../services';
import { ConditionalRender } from '../formControls';

const JoinLeaveMessageAudience = (props) => {
    const isInAudience = props.message?.audience?.some(e => e.userId === props.currentUserId && e.subscribed == true);

    const joinConversation = () => {
        updateAudiencePrefs(true);
    }

    const leaveConversation = () => {
        updateAudiencePrefs(false);
    }

    const updateAudiencePrefs = async (subscribed = true) => {
        //userId, messageId, 
        // props.currentUserId
        const messageService = new MessageService();
        let callResult = await messageService.updateAudiencePreference(props.currentUserId, props.message.id, subscribed);
        if (callResult.result) {
            props.updateCallback();
        }
        // props.message.id
    }

    return (
        <ConditionalRender visible={props.message}>
            <ConditionalRender visible={isInAudience}>
                <Button variant="secondary" onClick={() => leaveConversation()} size="sm">Leave conversation</Button>
            </ConditionalRender>
            <ConditionalRender visible={!isInAudience}>
                <Button variant="success" size="sm" onClick={() => joinConversation()}>Join conversation</Button>
            </ConditionalRender>
        </ConditionalRender>
    )
}

export default JoinLeaveMessageAudience;